import React, { Component } from 'react';

import analyticService from '../../../services/analytics';
import megatableService from '../megatable/megatable-service';

import { getClass } from '../../../utils/component-helpers';
import Tooltip from '../../misc/tooltip';

import loadingSpinner from '../../../images/icons/loader.png';
import exportIcon from '../../../images/icons/export.svg';
import disabledExportIcon from '../../../images/icons/export_disabled.svg';
import './dropdown.scss';
import './report-dropdown.scss';

class ReportDropdown extends Component {
	constructor(props) {
		super(props);

		this.AnalyticService = analyticService;
		this.service = megatableService;

		this.reportOptions = [
			{
				label: 'Visible',
				value: 'visible',
			},
			{
				label: 'All Rows',
				value: 'all',
			},
		];
		this.defaultOption = this.reportOptions[0].value;
		this.dropdownDiv = null;
		this.tooltipData = {text: 'Export CSV', size: 1};

		this.state = {
			opened: false,
			selectedOption: this.defaultOption,
			isGeneratingReport: false,
		};
	}

	componentDidMount() {
		window.addEventListener('click', (event) => this.handleClickOutside(event));
	}

	componentWillUnmount() {
		window.removeEventListener('click', (event) => this.handleClickOutside(event));
	}

	addTooltip(el) {
		if (el) {
			new Tooltip(el, this.tooltipData);
		}
	}

	toggleDropdown(event) {
		event.stopPropagation();

		const newState = {opened: !this.state.opened};
		if (!newState.opened) {
			newState.selectedOption = this.defaultOption;
		}

		this.setState(newState, () => {
			const gaLabel = this.state.opened ? '' : ' Cancel';
			this.AnalyticService.trackEvent(
				this.props.gaEvent.category, 'Click', `${this.props.gaEvent.label}${gaLabel}`
			);
		});
	}

	handleClickOutside(event) {
		if (!this.dropdownDiv || !this.state.opened ||
			this.dropdownDiv.contains(event.target)) return;

		this.toggleDropdown(event);
	}

	select(index, event) {
		event.stopPropagation();
		this.setState({selectedOption: this.reportOptions[index].value});
	}

	generateReport() {
		const optionLabel = this.reportOptions.find((option) => {
			return this.state.selectedOption === option.value;
		}).label;
		this.AnalyticService.trackEvent(
			this.props.gaEvent.category, 'Execute', `${this.props.gaEvent.label} ${optionLabel}`
		);
		this.setState({isGeneratingReport: true});

		const columns = this.props.columns
			.filter((column) => column.selected)
			.map((column) => column.name);

		// Adds edit_url column to report after edit_name to represent linkout
		if (this.props.statType === 'merchantArticleSearch') {
			const idx = columns.findIndex((column) => column === 'edit_name');
			columns.splice(idx+1, 0, 'edit_url');
		}

		const reportParams = {
			currentPage: this.props.currentPage,
			perPage: this.props.perPage,
			reportType: this.state.selectedOption,
		};

		return this.service.generateStatsReport(
			this.props.orgId, this.props.statType, columns,
			reportParams, this.props.queryParams
		).then((data) => {
			return this.service.checkReportReady(
				data.report_url, data.report_key, this.props.orgId, data.org_type, this.props.statType
			);
		}).then(() => {
			this.setState({isGeneratingReport: false});
		});
	}

	getDropdownList() {
		const getNumRows = (option) => {
			const rowCounts = this.props.rowCounts;
			if (rowCounts.visible > rowCounts.all) {
				return rowCounts.visible;
			}
			return option === 'visible' ? rowCounts.visible : rowCounts.all;
		};

		return (
			<ul className="dropdown-list">
				{this.reportOptions.map((item, index) => {
					return (
						<li
							key={index}
							className={getClass('dropdown-item', {
								'selected': this.state.selectedOption === item.value,
							})}
							onClick={(event) => this.select(index, event)}>
							<label>
								<span className="radio"></span>
								{`${item.label} (${getNumRows(item.value)})`}
							</label>
						</li>
					);
				})}
			</ul>
		);
	}

	getDropdownContents() {
		const prompt = this.state.selectedOption === 'all' ? (
			<p className="prompt">
				This can take up to 5 minutes to load.
				But don't worry! You can continue on with your life.
			</p>
		) : null;

		return this.state.opened ? (
			<div className="dropdown-menu">
				<h3>Export CSV</h3>
				{this.getDropdownList()}
				{prompt}
				<button
					onClick={this.toggleDropdown.bind(this)}
					className="cancel-btn">
					Cancel
				</button>
				<button
					onClick={this.generateReport.bind(this)}
					disabled={this.state.isGeneratingReport}
					className="done-btn">
					Download
				</button>
			</div>
		) : null;
	}

	render() {
		const isDisabled = this.props.disabled;
		const isGeneratingReport = this.state.isGeneratingReport;
		const exportButton = isGeneratingReport ? (
			<div className="loader-container">
				<img src={loadingSpinner} alt="Loading" />
			</div>
		) : (
			<img src={isDisabled ? disabledExportIcon : exportIcon} alt="export" />
		);
		return (
			<div
				ref={(node) => this.dropdownDiv = node}
				className={getClass('report-dropdown', {
					'disabled': isDisabled || isGeneratingReport,
				})} onClick={(event) => this.toggleDropdown(event)}>
				<button
					ref={(node) => this.addTooltip(node)}
					className={getClass('report-toggle', {
						'disabled': isDisabled,
						'opened': this.state.opened,
					})}>
					{exportButton}
				</button>
				{this.getDropdownContents()}
			</div>
		);
	}
}

export default ReportDropdown;
